

export const ProviderDocumentTypeValues = ["All", "835", "EOP", "Miscellaneous", "Pharmacy Contract"];
export type ProviderDocumentType = typeof ProviderDocumentTypeValues[number];

export interface PCDocumentListRequest {
  page_number?: number;
  results_per_page?: number;
  document_type?: ProviderDocumentType;
  created_at_start_date?: string;
  created_at_end_date?: string;
}

export interface DocumentSchema {
  id: string;
  rn: string;
  bucket: string;
  key: string;
  name: string;
  content_type: string;
  effective_date: string;
  termination_date: string;
  affiliation_type: string;
  affiliations: string[];
  agreement_type: string[];
  notes?: string;
  dea_certification_number?: string;
  controlled_substance_state?: string;
  controlled_substance_license_number?: string;
  pic_state?: string;
  pic_license_number?: string;
  pic_name?: string;
  license_state?: string;
  license_number?: string;
  license_provider_type?: string;
  credentialed?: boolean;
  recredentialed?: boolean;
  display_in_hcp?: boolean;
  line_of_business?: string[];
  agreement_version?: string;
  contractual_notice_email?: string;
  excluded_states?: string[];
  created_by?: string;
  created_at?: string;
  updated_at?: string;
}

export interface DocumentResponse {
  document: DocumentSchema;
}

export interface PCDocumentListResponse {
  result_count: string;
  results: DocumentResponse[];
}
